import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, FileText, PenTool, Newspaper, Brain, Network, Images } from "lucide-react";
import { useExam } from "@/context/ExamContext";

/**
 * Bottom Navigation Bar - SuperKalam Inspired Vibrant Design
 * Mobile-style navigation for quick access to main sections
 */
const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isSI } = useExam();

  // SI is an objective/OMR exam — no descriptive Mains or UPSC Optionals.
  // Swap those tabs for an Aptitude (CSAT) tab.
  const navItems = isSI
    ? [
        { id: "home", label: "Home", icon: Home, path: "/dashboard", activeColor: "from-indigo-500 to-purple-500" },
        { id: "mindmap", label: "Mindmaps", icon: Network, path: "/mindmap", activeColor: "from-violet-500 to-purple-500" },
        { id: "visual", label: "Visual", icon: Images, path: "/visual-resource", activeColor: "from-orange-500 to-amber-500" },
        { id: "prelims", label: "GS", icon: FileText, path: "/prelims", activeColor: "from-indigo-500 to-blue-500" },
        { id: "aptitude", label: "Aptitude", icon: Brain, path: "/csat-suite", activeColor: "from-purple-500 to-pink-500" },
        { id: "news", label: "News", icon: Newspaper, path: "/daily-intelligence", activeColor: "from-blue-500 to-cyan-500" },
      ]
    : [
        { id: "home", label: "Home", icon: Home, path: "/dashboard", activeColor: "from-indigo-500 to-purple-500" },
        { id: "mindmap", label: "Mindmaps", icon: Network, path: "/mindmap", activeColor: "from-violet-500 to-purple-500" },
        { id: "visual", label: "Visual", icon: Images, path: "/visual-resource", activeColor: "from-orange-500 to-amber-500" },
        { id: "prelims", label: "Prelims", icon: FileText, path: "/prelims", activeColor: "from-indigo-500 to-blue-500" },
        { id: "mains", label: "Mains", icon: PenTool, path: "/mains", activeColor: "from-purple-500 to-pink-500" },
        { id: "news", label: "News", icon: Newspaper, path: "/daily-intelligence", activeColor: "from-blue-500 to-cyan-500" },
      ];

  const isActive = (path) => {
    if (path === "/dashboard") {
      return location.pathname === "/dashboard" || location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-t border-slate-200/50 z-50 safe-area-bottom shadow-lg hidden sm:block">
      <div className="flex items-center justify-around py-1.5 px-2 max-w-lg mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center py-1 px-3 rounded-xl transition-all duration-200 ${
                active 
                  ? "scale-105" 
                  : "text-slate-500 hover:text-slate-700 active:scale-95"
              }`}
            >
              <div className={`p-2 rounded-xl transition-all duration-200 ${
                active 
                  ? `bg-gradient-to-r ${item.activeColor} shadow-md` 
                  : "hover:bg-slate-100"
              }`}>
                <Icon className={`w-5 h-5 ${active ? "text-white" : "text-slate-500"}`} />
              </div>
              <span className={`text-[10px] mt-1 font-semibold transition-colors ${
                active 
                  ? "text-transparent bg-clip-text bg-gradient-to-r " + item.activeColor 
                  : "text-slate-500"
              }`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
